"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
const type_rest_1 = require("type-rest");
const api_mapper_1 = require("../utilities/api-mapper");
const apiRoot = process.env.API_ROOT ? process.env.API_ROOT : null;
if (apiRoot === null)
    throw new Error("No api root found. App was built incorrectly or missing needed environment variables.");
exports.Api = (0, type_rest_1.typeRest)(apiRoot, {
    params: {
        mode: "cors",
        credentials: "include"
    }
});
exports.Api._addHook({
    type: "pre",
    hook: (event => {
        if (event.requestBody)
            event.requestBody = (0, api_mapper_1.toWire)(event.requestBody);
        if (event.requestQuery)
            event.requestQuery = (0, api_mapper_1.toWire)(event.requestQuery);
    })
});
exports.Api._addHook({
    type: "post",
    hook: (event) => {
        event.response = (0, api_mapper_1.fromWire)(event.response);
    }
});
//# sourceMappingURL=index.js.map